import { render, staticRenderFns } from "./PropertyPostingTable.vue?vue&type=template&id=21d91192&"
import script from "./PropertyPostingTable.vue?vue&type=script&lang=js&"
export * from "./PropertyPostingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports